// Targets a nudge is allowed to hand off. Anything else is refused
// before navigate() or dialog.open(). This is not the M3 authorization
// chain — it only stops an arbitrary confirmFlow target from becoming
// a navigation or a dialog key.

const NAVIGATE_PREFIXES = [
  '/home',
  '/brand',
  '/plans',
  '/integrations',
  '/image-studio',
  '/campaigns',
  '/product-ads',
  '/ads',
  '/render-activity',
  '/generate-ads',
  '/ugc-wizard',
  '/ugc-ads',
  '/detect',
  '/upload',
  '/media-library',
  '/catalog',
  '/settings',
  '/team',
  '/ad-showcase',
  '/v2'
] as const;

function safePath(target: string): string | null {
  const trimmed = target.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//') || trimmed.includes('\\')) return null;
  if (/[\u0000-\u001F\u007F]/.test(trimmed)) return null;
  try {
    const url = new URL(trimmed, 'https://reach-social.invalid');
    if (url.origin !== 'https://reach-social.invalid') return null;
    const path = url.pathname;
    if (path.split('/').some(part => part === '..' || part === '.')) return null;
    return path;
  } catch {
    return null;
  }
}

/** In-app path only. Returns the original string when the path is allowlisted. */
export function allowlistedNavigateTarget(target: unknown): string | null {
  if (typeof target !== 'string') return null;
  const path = safePath(target);
  if (!path) return null;
  const ok = NAVIGATE_PREFIXES.some(prefix => path === prefix || path.startsWith(prefix + '/'));
  return ok ? target.trim() : null;
}

/**
 * Dialog keys are slugs (`plan-draft`), never URLs or app paths.
 * A provider that receives one still has to open an M3 confirm UI —
 * this function only rejects targets that are obviously not keys.
 */
export function allowlistedDialogKey(target: unknown): string | null {
  if (typeof target !== 'string') return null;
  const trimmed = target.trim();
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(trimmed)) return null;
  return trimmed;
}
